import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IStep } from '../../interfaces/IStep';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CardComponent {
  @Input() data!: IStep;
}
